import { render, staticRenderFns } from "./Orderedit.vue?vue&type=template&id=5c5e9655&scoped=true"
import script from "./Orderedit.vue?vue&type=script&lang=js"
export * from "./Orderedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5e9655",
  null
  
)

export default component.exports